var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTap2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11896_149584)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.6784 40.1596L33.6783 40.1596L33.6813 40.163C33.871 40.3805 34.1373 40.492 34.4048 40.492C34.6256 40.492 34.8476 40.4162 35.0283 40.2615L34.9676 40.1905L35.0283 40.2615L37.9162 37.7895C38.2991 37.4617 38.3631 36.8934 38.0626 36.4887C38.0624 36.4885 38.0622 36.4882 38.062 36.488L33.6034 30.2774L33.6034 30.2774L33.6024 30.2761C33.5197 30.1649 33.474 30.0269 33.474 29.8885C33.474 29.5306 33.7652 29.2393 34.1231 29.2393H36.7308C37.2606 29.2393 37.6902 28.8098 37.6902 28.28V23.6494C37.6902 23.1195 37.2606 22.69 36.7308 22.69H36.0448V18.075C36.1684 17.5589 36.6875 15.3444 37.1474 12.6872C37.4145 11.4135 37.9472 8.09942 37.9472 5.00354V0.859375C37.9473 0.329508 37.5177 -0.1 36.9879 -0.1H28.8642C28.3344 -0.1 27.9048 0.329507 27.9048 0.859375V5.07023C27.9048 7.26939 28.2307 10.1476 28.8719 13.6232C29.2877 15.8779 29.6979 17.6213 29.8071 18.0756V22.6901H25.1107C24.1164 22.6901 23.2948 22.2186 22.7148 21.736C22.1388 21.2567 21.8099 20.7736 21.7988 20.7571C21.6236 20.4899 21.3162 20.3249 20.9974 20.3249H17.3982C16.8684 20.3249 16.4388 20.7544 16.4388 21.2843V22.69H14.553V21.284C14.553 20.7541 14.1234 20.3246 13.5937 20.3246H7.01172C6.48195 20.3246 6.05234 20.7541 6.05234 21.284V39.5326C6.05234 40.0625 6.48195 40.492 7.01172 40.492H7.48953H9.20828H11.5002H13.219H13.5937C14.1234 40.492 14.553 40.0625 14.553 39.5326V31.1351H16.4388V32.2124C16.4388 32.7422 16.8684 33.1718 17.3982 33.1718H20.9974C21.2368 33.1718 21.4739 33.0788 21.6495 32.916C23.0962 31.5753 24.8419 31.1998 25.1838 31.1371C25.9911 31.1575 26.7539 31.5149 27.2863 32.1249L33.6784 40.1596Z",
    fill: "#E2E2E2",
    stroke: "#E2E2E2",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11896_149584"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTap2);
export default __webpack_public_path__ + "static/media/tap2.2674ec2d0948045a46d94a437484d3b5.svg";
export { ForwardRef as ReactComponent };